export const isImage = (type: string, nameOrUrl: string) => {
  return (
    [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/webp",
      "image/gif",
      "image/bmp",
      "image/svg",
      "image/tiff",
      "image/heif",
      "png",
      "jpeg",
      "jpg",
      "webp",
      "gif",
      "bmp",
      "svg",
      "tiff",
      "heif"
    ].includes(type) || /\.(png|jpeg|jpg|webp|gif|bmp|svg|tiff|heif)(\?.*)?$/.test(nameOrUrl)
  );
};

export const isVideo = (type: string, nameOrUrl: string) =>
  ["video/mp4", "video/webm", "video/ogg", "video/quicktime"].includes(type) || /\.(mp4|mov|mpeg|mkv|webm)(\?.*)?$/.test(nameOrUrl);

export const renderInIframe = (type: string) => {
  return [
    "text/html",
    "text/css",
    "application/javascript",
    "text/plain",
    "application/xml",
    "application/pdf",
    "video/mp4",
    "video/webm",
    "video/ogg",
    "video/quicktime",
    "audio/mpeg",
    "audio/wav",
    "audio/ogg",
    "application/rss+xml",
    "application/octet-stream",
    "text/csv",
    "pdf",
    "mp4",
    "webm",
    "ogg",
    "wav",
    "csv"
  ].includes(type);
};
